export default {
  namespaced: true,
  state: {
    gameHubs: [],
    currentGameHub: null,
    loading: false,
    error: null,
  },
  mutations: {
    SET_GAME_HUBS(state, gameHubs) {
      state.gameHubs = gameHubs
    },
    SET_CURRENT_GAME_HUB(state, gameHub) {
      state.currentGameHub = gameHub
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
  },
  actions: {
    async fetchGameHubs({ commit }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const baseUrl = process.env.VUE_APP_COS_BASE_URL || ''
        const url = `${baseUrl}/gameHubs/index.json`
        const resp = await fetch(url)
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
        const gameHubs = await resp.json()
        commit('SET_GAME_HUBS', gameHubs)
        commit('SET_LOADING', false)
        return gameHubs
      } catch (error) {
        console.error('Error fetching game hubs:', error)
        commit('SET_ERROR', error.message)
        commit('SET_LOADING', false)
        commit('SET_GAME_HUBS', [])
        return []
      }
    },

    async fetchGameHubBySlug({ commit }, slug) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const baseUrl = process.env.VUE_APP_COS_BASE_URL || ''
        const url = `${baseUrl}/gameHubs/${slug}.json`
        const resp = await fetch(url)
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
        const gameHub = await resp.json()
        commit('SET_CURRENT_GAME_HUB', gameHub)
        commit('SET_LOADING', false)
        return gameHub
      } catch (error) {
        console.error(`Error fetching game hub ${slug}:`, error)
        commit('SET_ERROR', 'Game hub not found')
        commit('SET_CURRENT_GAME_HUB', null)
        commit('SET_LOADING', false)
        return null
      }
    },
  },
  getters: {
    getGameHubBySlug: (state) => (slug) => {
      return state.gameHubs.find(hub => hub.slug === slug) || null
    },
    getFeaturedGameHubs: (state) => (limit = 3) => {
      return state.gameHubs.slice(0, limit)
    },
  },
}
